export class Contact {
    PersonName: any; 
    CompanyName: any; 
    PhoneNumber: any; 
    EmailAddress: any;   
} 
 